import React from 'react';
import Button from '@marvelapp/marvel-ui/button';
import SmartLink from 'marketing-website/components/modules/SmartLink';

import CtaIllustration from 'marketing-website/components/modules/Cta/CtaIllustration';
import assets from 'marketing-website/configs/pages/why-marvel/assets.js';

export default function IntegrationsCta() {
  return (
    <div>
      <CtaIllustration
        {...assets.illustration}
        bgColor="purple"
        bgHeight={70}
        maxWidth={546}
        headingSize="xxl"
        title="Power up your workflow with integrations into your favourite tools "
        titleMaxWidth={420}
      >
        <SmartLink url="/features/integrations/">
          <Button
            isReversed
            kind="ghost"
            hover="white"
            color="slate"
            shape="rounded"
            size="large"
          >
            Explore integrations
          </Button>
        </SmartLink>
      </CtaIllustration>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/modules/IntegrationsCta/index.js